import { useEffect, useRef } from "react";
import Herosection from "../components/herosection/Herosection";
import Logos from "../components/logos/Logos";
import Digital from "../components/digital/Digital";
import Solution from "../components/solution/Solution";
import Features from "../components/features/Feature";
import Work from "../components/work/Work";
import Price from "../components/price/Price";
import Form from "../components/form/Form";
import Faqs from "../components/faqs/Faqs";
import WhatsappButton from "../components/whatsapp/WhatsappButton";
import {  formRef, scrollToForm } from "../components/utility/utility";

function ScrollReveal({ children, delay = 0 }) {
  const ref = useRef(null);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          el.style.transitionDelay = `${delay}ms`;
          el.classList.add("scroll-revealed");
          observer.unobserve(el);
        }
      },
      {
        threshold: 0.1,
        rootMargin: "0px 0px -60px 0px",
      }
    );

    observer.observe(el);
    return () => observer.disconnect();
  }, [delay]);

  return (
    <div ref={ref} className="scroll-hidden">
      {children}
    </div>
  );
}

export const  Home = ()=> {


 return (
  <div className="App">

      <Herosection onBookDemo={scrollToForm} />

      <ScrollReveal delay={0}>
        <Logos />
      </ScrollReveal>

      <ScrollReveal delay={20}>
        <Digital onBookDemo={scrollToForm} />
      </ScrollReveal>

      <ScrollReveal delay={20}>
        <Solution onBookDemo={scrollToForm} />
      </ScrollReveal>

      <ScrollReveal delay={20}>
        <Features onBookDemo={scrollToForm} />
      </ScrollReveal>

      <ScrollReveal delay={20}>
        <Work onBookDemo={scrollToForm} />
      </ScrollReveal>

      <ScrollReveal delay={20}>
        <Price onBookDemo={scrollToForm} />
      </ScrollReveal>

      {/* Attach ref to the Form wrapper */}
      <div ref={formRef}>
        <ScrollReveal delay={20}>
          <Form />
        </ScrollReveal>
      </div>

      <ScrollReveal delay={20}>
        <Faqs />
      </ScrollReveal>

      <WhatsappButton/>

  </div>
 )
}